import Disabled from "./Disabled";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import * as config from "config";

const options = Object.entries(config.US_STATE_NAMES).map(([k, v]) => {
  return { label: `${v} (${k})`, id: k, name: v };
});

const UsStatesSelector = ({ stateId, label, onChange, compact }) => {
  return (
    <Disabled ifReadOnly>
      <Autocomplete
        value={options.filter((option) => option.id === stateId)?.[0] ?? null}
        onChange={(_, value) => onChange(value?.id ?? null)}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label={compact ? null : label ?? "State"}
            variant={compact ? "outlined" : "filled"}
            InputLabelProps={{ shrink: true }}
            size={compact ? "small" : "medium"}
          />
        )}
        autoHighlight
      />
    </Disabled>
  );
};

export default UsStatesSelector;
